enum SimphonyInformationLineField {
  GuestName = 'guest-name',
  GuestPhoneNumber = 'guest-phone-number',
  GuestEmail = 'guest-email',
  OutpostName = 'outpost-name',
  TableNumber = 'table-number',
}

export { SimphonyInformationLineField };
